var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delay } from '@xyo-network/sdk-xyo-js';
import global from '../../global';
class Ttq {
    static init(pixelId) {
        try {
            Ttq.instance = new Ttq();
            Ttq.getTtq().load(pixelId);
            Ttq.page();
        }
        catch (ex) {
            console.error(`Ttq.init: ${ex}`);
        }
    }
    static getTtq() {
        return global.ttq;
    }
    static page() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                Ttq.getTtq().page();
                yield delay(0);
            }
            catch (ex) {
                console.error(`Ttq.page: ${ex}`);
            }
        });
    }
    track(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                Ttq.getTtq().track(event, Object.assign({}, data));
                yield delay(0);
            }
            catch (ex) {
                console.error(`Ttq.track: ${ex}`);
            }
        });
    }
}
export default Ttq;
//# sourceMappingURL=Ttq.js.map